export default __webpack_public_path__ + "static/media/unmatch-vehicle-red.db8ef454.svg";